/*
  mkbs-cart-fix.js — 8 septembre 2026 (v2)
  Correctifs du tiroir panier, charge par snippets/meta-tags.liquid.
  A terme, ces correctifs ont vocation a etre replies dans
  snippets/cart-drawer.liquid ; ce fichier evite d'avoir a reecrire
  ces 45 Ko de Liquid par l'API.

  1. Les deux blocs d'upsell du tiroir sont casses, chacun a sa facon.

     .ll-cart-upsell-btn (panier vide) : le theme attache un ecouteur par
     bouton au chargement de page. Des que le tiroir se redessine
     (renderContents), les nouveaux boutons n'ont plus d'ecouteur et le
     clic ne fait rien.

     .ll-drawer__up-btn (panier rempli) : l'ecouteur du theme est bien en
     delegation, mais il est rendu dans un bloc {% unless cart == empty %},
     donc il n'est jamais installe si la page a ete chargee avec un panier
     vide. De plus ces boutons sont dans le formulaire du panier sans
     attribut type, donc type="submit" par defaut : le clic soumet le
     formulaire et navigue vers /cart pendant que le fetch d'ajout est
     encore en vol.

     On prend donc les deux classes en charge ici, en phase de capture :
     preventDefault bloque la soumission du formulaire, stopPropagation
     empeche les ecouteurs du theme de faire un second ajout quand ils
     sont presents, et l'ajout se fait toujours depuis ce fichier.

  2. Bouton supprimer (.ll-ci__remove) : cible tactile de 24x24 px a
     12 px du bouton "+", sous le minimum de 44x44 px. On elargit la
     zone cliquable sans changer la taille visuelle, et on remplace la
     croix par une poubelle, comme sur la page /cart.
*/
(function () {
  if (window.__mkbsCartFix) return;
  window.__mkbsCartFix = true;

  /* ---------- 2. Bouton supprimer : cible 44x44 + icone poubelle ---------- */
  var TRASH =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 6h18'/%3E%3Cpath d='M8 6V4h8v2'/%3E%3Cpath d='M6 6l1 14h10l1-14'/%3E%3Cpath d='M10 11v6'/%3E%3Cpath d='M14 11v6'/%3E%3C/svg%3E\")";

  var css = document.createElement('style');
  css.id = 'mkbs-cart-fix-style';
  css.textContent = [
    'cart-remove-button .ll-ci__remove{',
    '  min-width:44px;min-height:44px;padding:0;',
    '  display:flex;align-items:center;justify-content:center;',
    '  margin-left:auto;margin-right:-10px;',
    '}',
    'cart-remove-button .ll-ci__remove svg{display:none;}',
    'cart-remove-button .ll-ci__remove::before{',
    '  content:"";width:18px;height:18px;flex:none;',
    '  background-color:currentColor;',
    '  -webkit-mask:' + TRASH + ' center/contain no-repeat;',
    '  mask:' + TRASH + ' center/contain no-repeat;',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(css);

  /* ---------- 1. Upsells : un seul ecouteur pour les deux blocs ---------- */
  function addVariant(variantId, btn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        drawer.classList.remove('is-empty');
        if (data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: variantId, sections: data.sections });
        }
      })
      .catch(function (err) {
        console.error('MKBS cart fix — ajout upsell', err);
        if (btn) btn.disabled = false;
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn =
        e.target.closest && e.target.closest('.ll-cart-upsell-btn, .ll-drawer__up-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      btn.disabled = true;
      addVariant(variantId, btn);
    },
    true
  );
})();
